import { render, staticRenderFns } from "./conactus.vue?vue&type=template&id=724f67b4&"
import script from "./conactus.vue?vue&type=script&lang=js&"
export * from "./conactus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports